import { useCallback, useState } from 'react';
import { useCreateImages } from '../media/useCreateImages';
export const useUploadFile = () => {
    const { mutateAsync: createImages } = useCreateImages();
    const [loadingFile, setLoadingFile] = useState();
    const setLoading = useCallback((file) => {
        if (!file) {
            setLoadingFile(undefined);
            return;
        }
        const fr = new FileReader();
        fr.onload = () => {
            setLoadingFile({ url: fr.result });
        };
        fr.readAsDataURL(file);
    }, []);
    const uploadFile = useCallback(async (file, updater) => {
        setLoading(file);
        const args = [{ file }];
        try {
            const uploadedImage = await createImages(args, {
                onError: () => {
                    setLoading();
                },
            });
            if (typeof updater === 'function') {
                await updater(uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage[0]);
            }
        }
        catch (e) {
            console.log(e);
        }
        setLoading();
    }, [createImages, setLoading]);
    return {
        uploadFile,
        loadingFile,
        loading: !!loadingFile,
    };
};
//# sourceMappingURL=useUploadFile.js.map